// src/components/Header.tsx

import React, { useState } from "react";
import "../../styles/Header.css";
import { appData } from "../../data/appData";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
const Header: React.FC = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  const excludedRoutes: string[] = ["/privacy", "/terms"];
  const filteredNavigation = appData.navigation.filter(
    (item) => !excludedRoutes.includes(item.href)
  );

  return (
    <header>
      <div className="header-container">
        <Link className="logo" to="/home" aria-label="AlluraTech home" onClick={() => setMenuOpen(false)}>
          <span className="brand-symbol" aria-hidden="true"><img src="/alluratech-brand.png" alt="" /></span>
          <span className="brand-wordmark" aria-hidden="true"><img src="/alluratech-brand.png" alt="" /></span>
        </Link>
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close navigation" : "Open navigation"}
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          type="button"
        >
          <span className="menu-icon">&#9776;</span>
        </button>
        <nav id="primary-navigation" className={`nav ${isMenuOpen ? "open" : ""}`} aria-label="Main navigation">
          <ul className="nav-links">
            {filteredNavigation.map((item) => (
              <li key={item.href} className={item.href === "/contact" ? "nav-contact" : undefined}>
                {/^https?:\/\//i.test(item.href) ? (
                  <a href={item.href} onClick={() => setMenuOpen(false)}>{item.name}</a>
                ) : (
                  <Link to={item.href} onClick={() => setMenuOpen(false)}>{item.name}</Link>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
